import { MapPin, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../../data";

const COVERAGE = [
  "Kota Yogyakarta",
  "Sleman",
  "Bantul",
  "Depok & Maguwoharjo",
  "Kaliurang & Pakem",
  "Malioboro & Tugu",
  "Prawirotaman & Kotagede",
  "Bandara YIA & sekitarnya",
];

export const CoverageMap = () => (
  <section id="peta" className="relative py-24 sm:py-32 bg-[#faf7f2]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Peta Jangkauan
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Seluruh area Jogja dapat kami jangkau.
        </h2>
        <p className="mt-5 max-w-xl text-[#5c4033] leading-relaxed">
          Di mana pun Anda berada di Daerah Istimewa Yogyakarta, terapis kami
          siap datang — bebas uang transport, buka 24 jam.
        </p>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-[1.6fr_1fr] gap-8 items-stretch">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-[#e5d9c5] shadow-[0_20px_50px_rgba(92,64,51,0.10)] h-[380px] sm:h-[480px]">
            <iframe
              title="Peta Jangkauan Javanese Spa Jogja - Yogyakarta"
              data-testid="coverage-map-iframe"
              src="https://maps.google.com/maps?q=Yogyakarta,%20Indonesia&z=11&output=embed"
              className="absolute inset-0 h-full w-full"
              style={{ border: 0, filter: "sepia(0.18) saturate(1.05)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="h-full rounded-3xl bg-[#2c1e16] text-[#faf7f2] p-8 flex flex-col">
            <MapPin className="h-7 w-7 text-[#b8862f]" strokeWidth={1.5} />
            <h3 className="font-display text-2xl sm:text-3xl mt-4 leading-tight">
              Area yang kami layani
            </h3>
            <ul className="mt-6 grid grid-cols-1 gap-3 flex-1">
              {COVERAGE.map((c) => (
                <li key={c} className="flex items-center gap-3 text-[#e5d9c5]">
                  <Check className="h-4 w-4 text-[#b8862f] shrink-0" />
                  <span className="text-sm">{c}</span>
                </li>
              ))}
            </ul>
            <a
              href={waLink("Halo Javanese Spa Jogja, saya mau cek apakah lokasi saya terjangkau untuk Massage panggilan.")}
              target="_blank"
              rel="noreferrer"
              data-testid="coverage-check-btn"
              className="mt-8 inline-block rounded-full bg-[#b8862f] text-[#2c1e16] px-6 py-3 text-sm font-medium text-center hover:bg-[#faf7f2] transition-colors"
            >
              Cek Lokasi Anda
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
